import { QueryError } from '@graphql-box/helpers';

import { useQuery } from '@graphql-box/react';
import { useTheme } from '@mui/material';
import { useEffect } from 'react';
import { tt } from '#i18n/index.ts';
import { deriveTvRibbonColor } from '../helpers/deriveRibbonColor.ts';
import { isTvRibbonWithinTimeframe } from '../helpers/isRibbonWithinTimeframe.ts';
import { Ribbon } from '../styled.ts';
import { type RibbonTvDetailsData, type TvRibbonProps } from '../types.ts';

const GET_RIBBON_TV_DETAILS = "query GetRibbonTvDetails(\n  $id: ID!\n) {\n  tv(id: $id) {\n    firstAirDate\n    lastAirDate\n    lastEpisodeToAir {\n      airDate\n    }\n    nextEpisodeToAir {\n      airDate\n    }\n  }\n}\n";

export const TvRibbon = ({ id, status, sx }: TvRibbonProps) => {
  const theme = useTheme();

  const { execute, result } = useQuery<RibbonTvDetailsData>(GET_RIBBON_TV_DETAILS, {
    loading: true,
  });

  useEffect(() => {
    void execute({ variables: { id } }, { data: { initiator: 'TvRibbon' } });
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (result instanceof QueryError) {
    console.error(result);
    return;
  }

  if (result?.errors?.length) {
    console.error(result.errors);
  }

  if (!result?.data || !isTvRibbonWithinTimeframe(status, result.data.tv)) {
    return;
  }

  return (
    <Ribbon ribbonColor={deriveTvRibbonColor(status, theme)} sx={sx}>
      <span>{tt(`ribbons.movieAndTv.${status}`)}</span>
    </Ribbon>
  );
};
